import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Collapse, Table } from 'reactstrap';
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";
import moment from "moment";
import emailValidator from 'email-validator';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { createDeepClone } from "../utils/index";

import BreadCrumb from '../components/Common/BreadCrumb';
import CardLoader from "../components/CardLoader";
import Lookup from "../components/Lookup";
import { Highlighter, Menu, MenuItem, } from 'react-bootstrap-typeahead';
import ActionList from "../components/ActionList";
import CustomerLookup from "../components/CustomerLookup";
import ConfirmModal from "../components/ConfirmModal";
import ConfirmModalAdvanced from "../components/ConfirmModalAdvanced";
import MyDateRenderer from "../components/MyDateRenderer";
import MyNumberRenderer from "../components/MyNumberRenderer";
import TicketPhotoGrid from "../components/TicketPhotoGrid";
import IneServiceDocumentGrid from "../components/IneServiceDocumentGrid";
import CommentGrid from "../components/CommentGrid";

import * as ineRequestActions from "../actions/IneRequestActions";
import * as commonActions from "../actions/CommonActions";

const IneRequestEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    
    const { id } = useParams();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.ine.loadingFBO);
    const fbo = useSelector((state) => state.ine.fbo);
    const user = useSelector((state) => state.login.user);
    
    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [refreshAction, setRefreshAction] = React.useState(false);
    const [selectedReporter, setSelectedReporter] = React.useState([]);
    const [selectedCustomer, setSelectedCustomer] = React.useState([]);
    const [invoiceInformationCollapsed, setInvoiceInformationCollapsed] = React.useState(true);
    
    const [isContainer, setIsContainer] = React.useState(false);
    const [isChild, setIsChild] = React.useState(false);
    const [isTicket, setIsTicket] = React.useState(false);
    
    const [selectedStatus, setSelectedStatus] = React.useState("");
    const [currentMessage, setCurrentMessage] = React.useState("");
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    const [showSubmitModal, setShowSubmitModal] = React.useState(false);
    const [showNewModal, setShowNewModal] = React.useState(false);
    const [showPendingApprovalModal, setShowPendingApprovalModal] = React.useState(false);
    const [showApproveModal, setShowApproveModal] = React.useState(false);
    const [showRejectModal, setShowRejectModal] = React.useState(false);
    const [showSalesActionModal, setShowSalesActionModal] = React.useState(false);
    const [showApprovalOfContractModal, setShowApprovalOfContractModal] = React.useState(false);
    const [showIssueWorkOrderFormModal, setShowIssueWorkOrderFormModal] = React.useState(false);
    const [showPerformInspectionModal, setShowPerformInspectionModal] = React.useState(false);
    const [showAwaitingSignatureModal, setShowAwaitingSignatureModal] = React.useState(false);
    const [showCompletedModal, setShowCompletedModal] = React.useState(false);
    const [showCloseModal, setShowCloseModal] = React.useState(false);
    const [showAbortedModal, setShowAbortedModal] = React.useState(false);

    const [clientEmailValid, setClientEmailValid] = React.useState(true);
    
    React.useEffect(() => {
        dispatch(ineRequestActions.loadIneRequest(id, navigate));
    }, [id]);

    React.useEffect(() => {
        setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        setSelectedReporter([]);
        setSelectedCustomer([]);

        setIsContainer(false);
        setIsChild(false);
        setIsTicket(false);

        if(fbo) {
            if(fbo.ineRequest.ticketType === "CONTAINER") {
                setIsContainer(true);
            }
            else if(fbo.ineRequest.ticketType === "CHILD") {
                setIsChild(true);
            }
            else if(fbo.ineRequest.ticketType === "TICKET") {
                setIsTicket(true);
            }
        }

        if(fbo != null) {
            reset(fbo.ineRequest);

            if(fbo.reporter != null) {
                setSelectedReporter(fbo.reporter);
            }

            if(fbo.customer != null) {
                setSelectedCustomer([fbo.customer]);
            }
        }

        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onChangeDocument = (isProduct, document, deleted) => {
        if(deleted) {
            if(document && document.documentType === "INE_ESTIMATE" && fboState) {
                var copy_fboState = createDeepClone(fboState);
                copy_fboState.ineRequest.quotationPrice = null;
                copy_fboState.ineRequest.quotationCurrency = null;
                copy_fboState.ineRequest.quotationFromSheet = false;
                setFBOState(copy_fboState);

                dispatch(ineRequestActions.saveIneRequest(copy_fboState, selectedStatus, currentMessage, navigate, true));
            }
        }
        else {
            if(document && document.documentType === "INE_ESTIMATE" && document.fob && document.fobCurrency && fboState) {
                var copy_fboState = createDeepClone(fboState);
                copy_fboState.ineRequest.quotationPrice = document.fob;
                copy_fboState.ineRequest.quotationCurrency = document.fobCurrency;
                copy_fboState.ineRequest.quotationFromSheet = true;
                setFBOState(copy_fboState);

                dispatch(ineRequestActions.saveIneRequest(copy_fboState, selectedStatus, currentMessage, navigate, true));
            }
        }

        setRefreshAction(!refreshAction);
    }

    const getQuotationPrice = () => {
        var value = 0;

        if(fboState && fboState.ineRequest && fboState.ineRequest.quotationPrice != null) {
            value = fboState.ineRequest.quotationPrice;
        }

        return value;
    }

    const onIneRequestChange = (name, value) => {
        var copy_fboState = createDeepClone(fboState);

        if(value) {
            if(name === "certificateIssueDate") {
                value = getDateWithoutTimezone(value);
            }
            else if(name === "quotationPrice") {
                value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            }
        }

        if(value) {
            copy_fboState.ineRequest[name] = value;
        }
        else if(value === false) {
            copy_fboState.ineRequest[name] = false;
        }
        else {
            copy_fboState.ineRequest[name] = null;
        }

        if(name === "certificateIssueDate" || name === "certificateDuration") {
            var date = copy_fboState.ineRequest["certificateIssueDate"];
            var duration = copy_fboState.ineRequest["certificateDuration"];

            if(date && duration) {
                if(duration == -1) {
                    copy_fboState.ineRequest["certificateExpiryDate"] = null;
                }
                else {
                    copy_fboState.ineRequest["certificateExpiryDate"] = getDateWithoutTimezone(new Date(moment(date).add(duration,'months').subtract(1, 'days')));
                }
            }
            else {
                copy_fboState.ineRequest["certificateExpiryDate"] = null;
            }
        }

        if(name === "clientEmail") {
            if(value) {
                if(emailValidator.validate(value)) {
                    setClientEmailValid(true);
                }
                else {
                    setClientEmailValid(false);
                }
            }
            else {
                setClientEmailValid(true);
            }
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIneRequesUserChange = (name, value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ineRequest[name] = null;
        }
        else {
            copy_fboState.ineRequest[name] = value;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onReporterChange = (items) => {
        setSelectedReporter(items);
        
        if(items.length > 0) {
            var ids = [];
            
            items.forEach(element => {
                ids.push(element.id);
            });

            onIneRequestChange("reporterUserId", ids.toString(), false);
        }
        else {
            onIneRequestChange("reporterUserId", null, false);
        }
    }

    const onScopeChange = (index) => {
        if(fboState.canEditScope) {
            var copy_fboState = createDeepClone(fboState);
            
            copy_fboState.testingScopeList.forEach((item, i) => {
                if(i === index) {
                    item.isSelected = true;
                }
                else {
                    item.isSelected = false;
                }
            });
            
            
            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const onSubScopeChange = (index, subIndex, checked) => {
        if(fboState.canEditScope) {
            var copy_fboState = createDeepClone(fboState);
            
            copy_fboState.testingScopeList[index].testingScopeDetailList[subIndex].isSelected = checked;

            if(copy_fboState.ineRequest.status !== "New") {
                copy_fboState.canNew = true;
            }
            
            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const getCurrentScopeId = () => {
        var scopeId = 0;

        if(fboState && fboState.testingScopeList) {
            fboState.testingScopeList.forEach((item, i) => {
                if(item.isSelected) {
                    scopeId = item.id;
                }
            });
        }

        return scopeId;
    }

    const onInspectorChange = (index, name, value) => {
        var copy_fboState = createDeepClone(fboState);
        

        if(value) {
            if(name === "inspectionStartDate" || name === "inspectionEndDate") {
                value = getDateWithoutTimezone(value);
            }
            
            copy_fboState.inspectorList[index][name] = value;
        }
        else if(value === false) {
            copy_fboState.inspectorList[index][name] = false;
        }
        else {
            copy_fboState.inspectorList[index][name] = null;
        }

        copy_fboState.inspectorList[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectorUserChange = (index, item) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(item.length > 0) {
            copy_fboState.inspectorList[index]["inspectionUserId"] = item[0].id;
            copy_fboState.inspectorList[index]["testingInspectorList"] = item;
        }
        else {
            copy_fboState.inspectorList[index]["inspectionUserId"] = null;
            copy_fboState.inspectorList[index]["testingInspectorList"] = item;
        }

        copy_fboState.inspectorList[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectorAdd = () => {
        var copy_fboState = createDeepClone(fboState);
        var copy_inspector = createDeepClone(fboState.inspector);
        
        copy_fboState.inspectorList.push(copy_inspector);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectorDelete = (inspector, index) => {
        var copy_fboState = createDeepClone(fboState);
        
        copy_fboState.inspectorList[index].isDeleted = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onLocationChange = (index, name, value) => {
        var copy_fboState = createDeepClone(fboState);

        if(value) {
            copy_fboState.locationList[index][name] = value;
        }
        else if(value === false) {
            copy_fboState.locationList[index][name] = false;
        }
        else {
            copy_fboState.locationList[index][name] = null;
        }

        copy_fboState.locationList[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onLocationAdd = () => {
        var copy_fboState = createDeepClone(fboState);
        var copy_location = createDeepClone(fboState.location);
        
        copy_fboState.locationList.push(copy_location);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onLocationDelete = (location, index) => {
        var copy_fboState = createDeepClone(fboState);
        
        copy_fboState.locationList[index].isDeleted = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const isCustomerReadonly = () => {
        if(fboState && (fboState.ineRequest.crmInvoiceId || fboState.ineRequest.status === "Closed")) {
            return true;
        }

        return false;
    }

    const onCustomerChange = (item) => {
        var copy_fboState = createDeepClone(fboState);
        setSelectedCustomer(item);
        
        if(item.length > 0) {
            copy_fboState.ineRequest["customerId"] = item[0].id.toString();
        }
        else {
            copy_fboState.ineRequest["customerId"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const UserRenderer = (results, menuProps, props) => (
        <Menu id="menuUserLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Name</div>
                    <div className="col">Email</div>
                    <div className="col">Employee ID</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullName || ''}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ''}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.employeeId || ''}
                            </Highlighter>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    const getFormattedDate = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy");
        }
        return "";
    }

    const getFormattedDateTime = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy HH:MM");
        }
        return "";
    }

    const getDateWithoutTimezone = (value) => {
        if(value) {
            const tzoffset = value.getTimezoneOffset() * 60000;
            const withoutTimezone = new Date(value.valueOf() - tzoffset).toISOString().slice(0, -1);
            return withoutTimezone;
        }
        return "";
    }

    const onSaveIneRequest = async() => {
        var valid = await trigger();

        if(valid) {
            if(fboState && fboState.canEditClient && fboState.ineRequest.clientEmail && !emailValidator.validate(fboState.ineRequest.clientEmail)) {
                dispatch(commonActions.setErrorMessage("Please input valid Client Email."));
                setClientEmailValid(false);
                valid = false;
            }
        }

        if(valid) {
            dispatch(ineRequestActions.saveIneRequest(fboState, selectedStatus, currentMessage, navigate, false));
        }

        onCloseModalClick();
    }

    const onApproveIneRequest = async() => {
        const valid = await trigger();

        if(valid) {
            dispatch(ineRequestActions.approveIneRequest(fboState.ineRequest.id, fboState.currentApproval.id, selectedStatus, currentMessage, navigate));
        }

        onCloseModalClick();
    }

    const onRejectIneRequest = async() => {
        const valid = await trigger();

        if(valid) {
            dispatch(ineRequestActions.approveIneRequest(fboState.ineRequest.id, fboState.currentApproval.id, selectedStatus, currentMessage, navigate));
        }

        onCloseModalClick();
    }

    const onCancelIneRequest = () => {
        setFBOState(fbo);

        if(fbo.reporter != null) {
            setSelectedReporter(fbo.reporter);
        }
        else {
            setSelectedReporter([]);
        }

        if(fbo.customer != null) {
            setSelectedCustomer([fbo.customer]);
        }
        else {
            setSelectedCustomer([]);
        }

        setIsDirty(false);
        clearErrors();
    }

    const onAssignMeTicket = async () => {
        dispatch(ineRequestActions.assignMeIneRequest(fboState.ineRequest.id, user.id, true, navigate));
        onCloseModalClick();
    }

    const onAssignMeTicketClick = () => {
        setShowAssignMeModal(true);
    }

    const onSubmitIneRequestClick = () => {
        setSelectedStatus("New");
        setCurrentMessage("");
        setShowSubmitModal(true);
    };

    const onNewIneRequestClick = () => {
        setSelectedStatus("New");
        setCurrentMessage("");
        setShowNewModal(true);
    };

    const onPendingApprovalIneRequestClick = () => {
        setSelectedStatus("Pending Approval");
        setCurrentMessage("");
        setShowPendingApprovalModal(true);
    };

    const onApproveIneRequestClick = () => {
        setSelectedStatus("Approved");
        setCurrentMessage("");
        setShowApproveModal(true);
    };

    const onRejectIneRequestClick = () => {
        setSelectedStatus("Rejected");
        setCurrentMessage("");
        setShowRejectModal(true);
    };

    const onSalesActionClick = () => {
        setSelectedStatus("Sales Action");
        setCurrentMessage("");
        setShowSalesActionModal(true);
    }

    const onApprovalOfContractClick = () => {
        setSelectedStatus("Approval Of Contract");
        setCurrentMessage("");
        setShowApprovalOfContractModal(true);
    }

    const onIssueWorkOrderFormClick = () => {
        setSelectedStatus("Issue Work Order Form");
        setCurrentMessage("");
        setShowIssueWorkOrderFormModal(true);
    }

    const onPerformInspectionClick = () => {
        setSelectedStatus("Perform Inspection");
        setCurrentMessage("");
        setShowPerformInspectionModal(true);
    }
    
    const onAwaitingSignatureClick = () => {
        setSelectedStatus("Awaiting Signature");
        setCurrentMessage("");
        setShowAwaitingSignatureModal(true);
    }

    const onCompletedClick = () => {
        setSelectedStatus("Completed");
        setCurrentMessage("");
        setShowCompletedModal(true);
    }

    const onCloseClick = () => {
        setSelectedStatus("Closed");
        setCurrentMessage("");
        setShowCloseModal(true);
    }

    const onAbortedClick = () => {
        setSelectedStatus("Aborted");
        setCurrentMessage("");
        setShowAbortedModal(true);
    }

    const onCloseModalClick = () => {
        setSelectedStatus("");
        setCurrentMessage("");
        
        setShowAssignMeModal(false);
        setShowSubmitModal(false);
        setShowNewModal(false);
        setShowPendingApprovalModal(false);
        setShowApproveModal(false);
        setShowRejectModal(false);
        setShowSalesActionModal(false);
        setShowApprovalOfContractModal(false);
        setShowIssueWorkOrderFormModal(false);
        setShowPerformInspectionModal(false);
        setShowAwaitingSignatureModal(false);
        setShowCompletedModal(false);
        setShowCloseModal(false);
        setShowAbortedModal(false);
    }

    return(
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title={`Edit INE Ticket ${isContainer ? "Container" : ""}`} />
                <Row>
                    <Col xl={9}>
                        <CardLoader loading={loading} />

                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">
                                    INE Ticket {isContainer ? "Container" : ""}
                                    {isChild && 
                                    <span style={{fontSize:"70%"}} className="ms-1">
                                        <Link to={`/ine-request-edit/${fboState && fboState.ineRequest.parentId}`}>
                                            (view container)
                                        </Link>
                                    </span>
                                    }
                                </h5>      
                                <div className="flex-shrink-1 ms-3">
                                    <div className="d-flex flex-wrap gap-2">
                                        {fboState && fboState.canSave &&
                                        <button className="btn btn-primary btn-label"
                                            disabled={loading || !isDirty}
                                            onClick={onSaveIneRequest}
                                        >
                                            <i className="ri-save-line label-icon align-middle"></i> Save INE Ticket {isContainer ? "Container" : ""}
                                        </button>
                                        }
                                        {fboState && fboState.canSave &&
                                        <button className="btn btn-danger btn-label"
                                            disabled={loading || !isDirty}
                                            onClick={onCancelIneRequest}
                                        >
                                            <i className="ri-close-line label-icon align-middle"></i>
                                            Cancel
                                        </button>
                                        }
                                        {fboState && fboState.canAssignMe &&
                                        <button className="btn btn-primary btn-label"
                                            disabled={loading}
                                            onClick={() => onAssignMeTicketClick()}
                                        >
                                            <i className="ri-user-follow-line label-icon align-bottom"></i> Assign Me INE Ticket {isContainer ? "Container" : ""}
                                        </button>
                                        }
                                        {fboState && fboState.canSubmit &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onSubmitIneRequestClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Submit
                                        </button>
                                        }
                                        {fboState && fboState.canNew &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onNewIneRequestClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Redo Cost Estimation
                                        </button>
                                        }
                                        {fboState && fboState.canPendingApproval &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onPendingApprovalIneRequestClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> {getQuotationPrice() <= 10000 ? "Submit to Sales Action" : "Submit for Budget Approval"}
                                        </button>
                                        }
                                        {fboState && fboState.canApprove &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onApproveIneRequestClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Approve
                                        </button>
                                        }
                                        {fboState && fboState.canReject &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onRejectIneRequestClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Reject
                                        </button>
                                        }
                                        {fboState && fboState.canSalesAction &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onSalesActionClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Sales Action
                                        </button>
                                        }
                                        {fboState && fboState.canApprovalOfContract &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onApprovalOfContractClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Approval Of Contract
                                        </button>
                                        }
                                        {fboState && fboState.canIssueWorkOrderForm &&
                                        <button className={`btn ${fboState && fboState.isPerformInspection ? "btn-danger" : "btn-secondary"} btn-label`}
                                            disabled={loading}
                                            onClick={onIssueWorkOrderFormClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isPerformInspection ? "Area Manager Support" : "Issue Work Order Form"}
                                        </button>
                                        }
                                        {fboState && fboState.canPerformInspection &&
                                        <button className="btn btn-secondary btn-label" 
                                            disabled={loading}
                                            onClick={onPerformInspectionClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isAwaitingSignature ? "Return to Inspector" : "Perform Inspection"}
                                        </button>
                                        }
                                        {fboState && fboState.canAwaitingSignature &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onAwaitingSignatureClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Awaiting Signature
                                        </button>
                                        }
                                        {fboState && fboState.canCompleted &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onCompletedClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Completed
                                        </button>
                                        }
                                        {fboState && fboState.canClosed &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onCloseClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Close
                                        </button>
                                        }
                                        {fboState && fboState.canAborted &&
                                        <button className="btn btn-secondary btn-label"
                                            disabled={loading}
                                            onClick={onAbortedClick}
                                        >
                                            <i className="ri-check-double-line label-icon align-bottom"></i> Abort
                                        </button>
                                        }
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Ticket #</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                            value={(fboState && fboState.ineRequest.requestNumber) || ""}
                                            onChange={e => onIneRequestChange("requestNumber", e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Status</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                            value={(fboState && fboState.ineRequest.status) || ""}
                                            onChange={e => onIneRequestChange("status", e.target.value)}
                                        />
                                    </Col>
                                    {fboState && fboState.showContractNumber &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Ref. / Contract Number{fboState && fboState.isContractNumberRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditContractNumber ? false : true}
                                            value={(fboState && fboState.ineRequest.contractNumber) || ""}
                                            onChange={e => onIneRequestChange("contractNumber", e.target.value)}
                                        />
                                    </Col>
                                    }
                                    
                                    {fboState && fboState.showCostEstimation &&
                                    <Fragment>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Cost Estimation Value{fboState && fboState.isCostEstimationRequired && <span className="required">*</span>}</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditCostEstimation ? false : true}
                                                value={fboState?.ineRequest?.quotationPrice ?? ""}
                                                onChange={e => onIneRequestChange("quotationPrice", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Cost Estimation Currency{fboState && fboState.isCostEstimationRequired && <span className="required">*</span>}</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditCostEstimation ? false : true}
                                                value={(fboState && fboState.ineRequest.quotationCurrency) || ""}
                                                onChange={e => onIneRequesUserChange("quotationCurrency", e.target.value, false)}
                                            >
                                                <option value={""}>...</option>
                                                <option value="AED">UAE Dirham</option>
                                                <option value="CNY">China Yuan</option>
                                                <option value="EUR">Euro</option>
                                                <option value="USD">USA Dollar</option>
                                                <option value="LKR">Sri Lanka Rupee</option>
                                                <option value="EGP">Egypt Pound</option>
                                                <option value="SAR">Saudi Riyal</option>
                                                <option value="INR">India Rupee</option>
                                            </select>
                                        </Col>
                                    </Fragment>
                                    }
                                    {fboState && fboState.showProjectNumber &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Project / Reference Number{fboState && fboState.isProjectNumberRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditProjectNumber ? false : true}
                                            value={(fboState && fboState.ineRequest.projectNumber) || ""}
                                            onChange={e => onIneRequestChange("projectNumber", e.target.value)}
                                        />
                                    </Col>
                                    }
                                    {fboState && fboState.showQuotationNumber &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Quotation Number{fboState && fboState.isQuotationNumberRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditQuotationNumber ? false : true}
                                            value={(fboState && fboState.ineRequest.quotationNumber) || ""}
                                            onChange={e => onIneRequestChange("quotationNumber", e.target.value)}
                                        />
                                    </Col>
                                    }
                                    {fboState && fboState.showPurchaseOrderNumber &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Purchase Order Number{fboState && fboState.isPurchaseOrderNumberRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditPurchaseOrderNumber ? false : true}
                                            value={(fboState && fboState.ineRequest.purchaseOrderNumber) || ""}
                                            onChange={e => onIneRequestChange("purchaseOrderNumber", e.target.value)}
                                        />
                                    </Col>
                                    }
                                    <Col xxl={12} md={12}>
                                        <Label className="form-label">Remarks</Label>
                                        <input type="text" maxLength={512} className="form-control" placeholder="optional..."
                                            value={(fboState && fboState.ineRequest.description) || ""}
                                            onChange={e => onIneRequestChange("description", e.target.value, false)}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {fboState && fboState.approvalList && fboState.approvalList.length > 0 &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Ticket Approvals</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    <Table className="table-hover table-bordered align-middle mb-0">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Approval Type</th>
                                                <th>Approval Status</th>
                                                <th>Approved By</th>
                                                <th>Approved Date</th>
                                                <th className="w-50">Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fboState.approvalList.length == 0 && <tr><td colSpan={7}>No Approvals</td></tr>}
                                            {fboState.approvalList.map(function(item, index){
                                                return(
                                                    <tr key={index}>
                                                        <td>{item.approvalTypeName || item.approvalType}</td>
                                                        <td>
                                                            {item.isPending && <span className="badge bg-warning">{item.approvalStatus}</span>}
                                                            {item.isApproved && <span className="badge bg-success">{item.approvalStatus}</span>}
                                                            {item.isRejected && <span className="badge bg-danger">{item.approvalStatus}</span>}
                                                        </td>
                                                        <td>{item.approvedByUserName}</td>
                                                        <td><MyDateRenderer value={item.approvedDate} /></td>
                                                        <td>{item.comments}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Row>
                            </CardBody>
                        </Card>
                        }

                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Ticket Users</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    {fboState && fboState.showAreaManagerUser &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Area Manager{fboState && fboState.isAreaManagerUserRequired && <span className="required">*</span>}</Label>
                                        <select className="form-select" disabled={fboState && fboState.canEditAreaManagerUser ? false : true}
                                            value={(fboState && fboState.ineRequest.areaManagerUserId) || ""}
                                            onChange={e => onIneRequesUserChange("areaManagerUserId", e.target.value, false)}
                                        >
                                            <option value={0}>...</option>
                                            {fboState && fboState.areaManagerUserList.map(function(item, index){
                                                return (
                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    }
                                    {fboState && fboState.showTechnicalManagerUser &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Technical Manager</Label>
                                        <select className="form-select" disabled={fboState && fboState.canEditTechnicalManagerUser ? false : true}
                                            value={(fboState && fboState.ineRequest.technicalManagerUserId) || ""}
                                            onChange={e => onIneRequesUserChange("technicalManagerUserId", e.target.value, false)}
                                        >
                                            <option value={0}>...</option>
                                            {fboState && fboState.technicalManagerUserList.map(function(item, index){
                                                return (
                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    }
                                    {fboState && fboState.showFinanceUser &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Finance</Label>
                                        <select className="form-select" disabled={fboState && fboState.canEditFinanceUser ? false : true}
                                            value={(fboState && fboState.ineRequest.financeUserId) || ""}
                                            onChange={e => onIneRequesUserChange("financeUserId", e.target.value, false)}
                                        >
                                            <option value={0}>...</option>
                                            {fboState && fboState.financeUserList.map(function(item, index){
                                                return (
                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    }
                                    {fboState && fboState.showStoreKeeperUser &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Store Keeper</Label>
                                        <select className="form-select" disabled={fboState && fboState.canEditStoreKeeperUser ? false : true}
                                            value={(fboState && fboState.ineRequest.storeKeeperUserId) || ""}
                                            onChange={e => onIneRequesUserChange("storeKeeperUserId", e.target.value, false)}
                                        >
                                            <option value={0}>...</option>
                                            {fboState && fboState.storeKeeperUserList.map(function(item, index){
                                                return (
                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    }
                                    <Col xxl={12} md={12}>
                                        <Label className="form-label">Allow Access To <span className="text-primary" style={{fontSize:12}}><i>(Ticket will be shared with other user(s))</i></span></Label>
                                        <Typeahead
                                            id="fldReporterUserIds"
                                            multiple
                                            disabled={fboState && fboState.canEditReporter ? false : true}
                                            labelKey= {option => `${option.fullName}`}
                                            options={fboState && fboState.reporterUserList || []}
                                            placeholder="Select Reporter..."
                                            selected = {selectedReporter}
                                            onChange = {(item) => onReporterChange(item)}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {fboState && fboState.showCustomer &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Customer Information</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">CRM Name</Label>
                                        <select className="form-select" disabled={isCustomerReadonly()}
                                            value={(fboState && fboState.ineRequest.crmName) || ""}
                                            onChange={e => onIneRequestChange("crmName", e.target.value, false)}
                                        >
                                            <option value="">...</option>
                                            {fboState && fboState.crmList.map(function(item, index){
                                                return (
                                                    <option key={index} value={item.crmNameIni}>{item.crmLabel}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Invoice Country</Label>
                                        <select className="form-select" disabled={isCustomerReadonly()}
                                            value={(fboState && fboState.ineRequest.crmCountry) || ""}
                                            onChange={e => onIneRequestChange("crmCountry", e.target.value, false)}
                                        >
                                            <option value="">...</option>
                                            {fboState && fboState.crmCountryList.filter(x => x.crmNameIni == fboState.ineRequest.crmName).map(function(item, index){
                                                return (
                                                    <option key={index} value={item.countryName}>{item.countryLabel}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    <Col xxl={4} md={6}>&nbsp;</Col>
                                    {isCustomerReadonly() &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Customer Code</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].code + ' - ' + selectedCustomer[0].crmCountry) || ""}
                                        />
                                    </Col>
                                    }
                                    {!isCustomerReadonly() &&
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Customer Code</Label>
                                        <CustomerLookup
                                            id ="fldCustomerLookup2"
                                            crmName={(fboState && fboState.ineRequest.crmName) || ""}
                                            selected = {selectedCustomer}
                                            onChange = {(item) => onCustomerChange(item)}
                                        />
                                    </Col>
                                    }
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Organization Name</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].organizationName) || ""}
                                        />
                                    </Col>
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Contact Name</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].fullName) || ""}
                                        />
                                    </Col>
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Email</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].email) || ""}
                                        />
                                    </Col>
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Phone Number</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].telephoneNumber) || ""}
                                        />
                                    </Col>
                                    <Col xxl={4} md={6}>
                                        <Label className="form-label">Fax Number</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].faxNumber) || ""}
                                        />
                                    </Col>
                                    <Col xxl={12} md={12}>
                                        <Label className="form-label">Address</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].fullAddress) || ""}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        }

                        {fboState && fboState.showInvoice &&
                        <Card className="mb-0 card-light">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setInvoiceInformationCollapsed(!invoiceInformationCollapsed)}>
                                    {invoiceInformationCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                    {!invoiceInformationCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                    Invoice Information
                                </h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                <Collapse isOpen={!invoiceInformationCollapsed} className="collapse">
                                    {fboState && fboState.invoiceList && fboState.invoiceList.map(function(invoice, index) {
                                        return(
                                            <Fragment key={index}>
                                                {index > 0 &&
                                                    <Row className="gy-2">
                                                        <Col xxl={12} md={12}>
                                                            <Label className="form-label">&nbsp;</Label>
                                                            <hr />
                                                        </Col>
                                                    </Row>
                                                }
                                                <Row className="gy-2">
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Currency</Label>
                                                        <select className="form-select" disabled={true}
                                                            value={(invoice.currency) || ""}
                                                            onChange={e => onIneRequestChange("currency", e.target.value, false)}
                                                        >
                                                            <option value={""}>...</option>
                                                            <option value="AED">UAE Dirham</option>
                                                            <option value="CNY">China Yuan</option>
                                                            <option value="EUR">Euro</option>
                                                            <option value="USD">USA Dollar</option>
                                                            <option value="LKR">Sri Lanka Rupee</option>
                                                            <option value="EGP">Egypt Pound</option>
                                                            <option value="SAR">Saudi Riyal</option>
                                                            <option value="INR">India Rupee</option>
                                                        </select>
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">CRM Invoice #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.crmInvoiceNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Tax Invoice #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.taxInvoiceNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Quote #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.quoteNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Product Name</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.productName) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Product Description</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.productDescription) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Quantity</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.quantity) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Price</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.listPrice) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">Total Price</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.listPriceTotal) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">Discount Type</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.discountType) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">Discount</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.discountAmount) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">VAT %</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.vatPercentage) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">VAT</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.vat) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">Total</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(invoice.price) || ""}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        );
                                    })}
                                    {fboState && fboState.invoiceList && fboState.invoiceList.length == 0 &&
                                        <Row className="gy-2">
                                            <Label>No Invoice Linked</Label>
                                        </Row>
                                    }
                                </Collapse>
                            </CardBody>
                        </Card>
                        }

                        {fboState && fboState.showScope &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Scope{fboState && fboState.isScopeRequired && <span className="required">*</span>}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    {fboState && fboState.testingScopeList.map(function(item, index){
                                        return (
                                            <Fragment key={index}>
                                                <Col xxl={12} md={12}>
                                                    <div className="form-check mb-1">
                                                        <input type="radio" className="form-check-input" disabled={fboState && fboState.canChangeScope ? false : true}
                                                            checked={item.isSelected}
                                                            onChange={e => onScopeChange(index)}
                                                        />
                                                        <Label className="mt-0">{item.name}</Label>
                                                    </div>
                                                </Col>
                                                <Row className={`mt-2 ms-2 mb-2 ${item.isSelected ? "" : "d-none"}`}>
                                                    {item.testingScopeDetailList.map(function(subItem, subIndex){
                                                        return (
                                                            <Col xxl={6} md={6} key={subIndex}>
                                                                <div className="form-check mb-1">
                                                                    <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditScope ? false : true}
                                                                        checked={subItem.isSelected}
                                                                        onChange={e => onSubScopeChange(index, subIndex, e.target.checked)}
                                                                    />
                                                                    <Label className="mt-0">{subItem.name}</Label>
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                            </Fragment>
                                        );
                                    })}
                                </Row>
                            </CardBody>
                        </Card>
                        }

                        {fboState && fboState.showInspection &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Inspector Assignment{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</h5>
                                <div className="flex-shrink-0">
                                    <div className="d-flex flex-wrap gap-2">
                                        {fboState && fboState.canEditSite &&
                                        <button className="btn btn-primary btn-label"
                                            onClick={() => onInspectorAdd()}
                                        >
                                            <i className="ri-add-line label-icon align-bottom"></i> Add Inspector
                                        </button>
                                        }
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                {fboState && fboState.inspectorList && fboState.inspectorList.map(function(inspector, index) {
                                    return(
                                        <Card className={`card-light ${inspector.isDeleted ? "d-none" : ""}`} key={index}>
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Inspector # {index + 1}</h5>
                                                <div className="flex-shrink-0">
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {fboState && fboState.canEditSite && fboState.inspectorList.filter(x=> x.isDeleted === false).length > 1 && 
                                                        <button type="button" className="btn btn-danger btn-icon rounded-pill float-end fs-11 me-1" title="Delete"
                                                            onClick={() => onInspectorDelete(inspector, index)}
                                                        >
                                                            <i className="ri-delete-bin-2-line" />
                                                        </button>
                                                        }
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <CardBody className="border border-dashed card-text">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Inspector Category{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canEditInspection ? false : true}
                                                            value={inspector.inspectionUserType || ""}
                                                            onChange={e => onInspectorChange(index, "inspectionUserType", e.target.value)}
                                                        >
                                                            <option value={""}>...</option>
                                                            <option value={"Internal"}>Internal</option>
                                                            <option value={"External"}>External</option>
                                                        </select>
                                                    </Col>
                                                    <div className="clearDiv"></div>
                                                    {inspector.inspectionUserType === "Internal" &&
                                                    <Fragment>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Inspector Name{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                            <div className="input-group">
                                                                <Lookup
                                                                    clearButton 
                                                                    disabled={fboState && fboState.canEditInspection ? false : true}
                                                                    allowNew ={false} 
                                                                    id ={`fldTestingInspector${index}`}
                                                                    url = {`GetIneInspectorLookup?scopeId=${getCurrentScopeId()}&index=${index}`}
                                                                    defaultSearch={inspector.inspectionUserId || ""}
                                                                    placeholder= "Select Inspector..."
                                                                    labelKey= {option => `${option.fullName || ""}`}
                                                                    selected = {inspector.testingInspectorList}
                                                                    onChange = {(item) => onInspectorUserChange(index, item)}
                                                                    renderMenu = {UserRenderer}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Inspector Email</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(inspector.testingInspectorList.length > 0 && inspector.testingInspectorList[0].email) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Inspector Phone</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(inspector.testingInspectorList.length > 0 && inspector.testingInspectorList[0].telephoneNumber) || ""}
                                                            />
                                                        </Col>
                                                    </Fragment>
                                                    }
                                                    {inspector.inspectionUserType === "External" &&
                                                    <Fragment>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Inspector Name{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditInspection ? false : true}
                                                                value={inspector.inspectionPersonName || ""}
                                                                onChange={e => onInspectorChange(index, "inspectionPersonName", e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Inspector Email{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditInspection ? false : true}
                                                                value={inspector.inspectionPersonEmail || ""}
                                                                onChange={e => onInspectorChange(index, "inspectionPersonEmail", e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Inspector Phone{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditInspection ? false : true}
                                                                value={inspector.inspectionPersonContact || ""}
                                                                onChange={e => onInspectorChange(index, "inspectionPersonContact", e.target.value)}
                                                            />
                                                        </Col>
                                                    </Fragment>
                                                    }
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Inspection Start Date{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                        {fboState && fboState.canEditInspection &&
                                                        <Flatpickr className="form-control"
                                                            value={getFormattedDate(inspector.inspectionStartDate) || ""}
                                                            onChange={([date]) => onInspectorChange(index, "inspectionStartDate", date)}
                                                            options={{
                                                                enableTime: false,
                                                                dateFormat: "m/d/Y",
                                                                minDate: "today"
                                                            }}
                                                        />
                                                        }
                                                        {fboState && !fboState.canEditInspection &&
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={getFormattedDate(inspector.inspectionStartDate) || ""}
                                                        />
                                                        }
                                                    </Col>
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Inspection End Date{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                        {fboState && fboState.canEditInspection &&
                                                        <Flatpickr className="form-control"
                                                            value={getFormattedDate(inspector.inspectionEndDate) || ""}
                                                            onChange={([date]) => onInspectorChange(index, "inspectionEndDate", date)}
                                                            options={{
                                                                enableTime: false,
                                                                dateFormat: "m/d/Y",
                                                                minDate: "today"
                                                            }}
                                                        />
                                                        }
                                                        {fboState && !fboState.canEditInspection &&
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={getFormattedDate(inspector.inspectionEndDate) || ""}
                                                        />
                                                        }
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    );
                                })}

                                <Row className="gy-2">
                                    
                                    <Col xxl={4} md={4}>
                                        <Label className="form-label">Scheduling Status{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                        <select className="form-select" disabled={fboState && fboState.canEditInspection ? false : true}
                                            value={(fboState && fboState.ineRequest.inspectionStatus) || ""}
                                            onChange={e => onIneRequestChange("inspectionStatus", e.target.value, false)}
                                        >
                                            <option value="">...</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Confirmed">Confirmed</option>
                                        </select>
                                    </Col>
                                    <Col xxl={12} md={12}>
                                        <Label className="form-label">Remarks / Comments</Label>
                                        <textarea maxLength={512} className="form-control" rows="5" readOnly={fboState && fboState.canEditInspection ? false : true}
                                            value={(fboState && fboState.ineRequest.inspectionComments) || ""}
                                            onChange={e => onIneRequestChange("inspectionComments", e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        }

                        {fboState && fboState.showSite &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Site & Inspection Details{fboState && fboState.isSiteRequired && <span className="required">*</span>}</h5>
                                <div className="flex-shrink-0">
                                    <div className="d-flex flex-wrap gap-2">
                                        {fboState && fboState.canEditSite &&
                                        <button className="btn btn-primary btn-label"
                                            onClick={() => onLocationAdd()}
                                        >
                                            <i className="ri-add-line label-icon align-bottom"></i> Add Site
                                        </button>
                                        }
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                {fboState && fboState.locationList && fboState.locationList.map(function(location, index) {
                                    return(
                                        <Card className={`card-light ${location.isDeleted ? "d-none" : ""}`} key={index}>
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Site # {index + 1}</h5>
                                                <div className="flex-shrink-0">
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {fboState && fboState.canEditSite && fboState.locationList.filter(x=> x.isDeleted === false).length > 1 && 
                                                        <button type="button" className="btn btn-danger btn-icon rounded-pill float-end fs-11 me-1" title="Delete"
                                                            onClick={() => onLocationDelete(location, index)}
                                                        >
                                                            <i className="ri-delete-bin-2-line" />
                                                        </button>
                                                        }
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <CardBody className="border border-dashed card-text">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={4}>
                                                        <Label className="form-label">Site Contact Name{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteContactName) || ""}
                                                            onChange={e => onLocationChange(index, "siteContactName", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={4}>
                                                        <Label className="form-label">Site Contact Email{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteContactEmail) || ""}
                                                            onChange={e => onLocationChange(index, "siteContactEmail", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={4}>
                                                        <Label className="form-label">Site Contact Phone{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteContactPhone) || ""}
                                                            onChange={e => onLocationChange(index, "siteContactPhone", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} md={12}>
                                                        <Label className="form-label">Site Contact Location{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteContactLocation) || ""}
                                                            onChange={e => onLocationChange(index, "siteContactLocation", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={2}>
                                                        <Label className="form-label">Country{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteCountry) || ""}
                                                            onChange={e => onLocationChange(index, "siteCountry", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="Saudi Arabia">Saudi Arabia</option>
                                                        </select>
                                                    </Col>
                                                    <Col xxl={2} md={2}>
                                                        <Label className="form-label">Region{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteRegion) || ""}
                                                            onChange={e => onLocationChange(index, "siteRegion", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="Jubail">Jubail</option>
                                                            <option value="Riyadh">Riyadh</option>
                                                            <option value="Yanbu">Yanbu</option>
                                                            <option value="Jeddah">Jeddah</option>
                                                            <option value="Al-Hasa 1">Al-Hasa 1</option>
                                                            <option value="Al-Hasa 2">Al-Hasa 2</option>
                                                            <option value="Al-Hasa 3">Al-Hasa 3</option>
                                                            <option value="Dammam 1">Dammam 1</option>
                                                            <option value="Dammam 2">Dammam 2</option>
                                                            <option value="Khobar">Khobar</option>
                                                            <option value="Tabuk / Neom">Tabuk / Neom</option>
                                                        </select>
                                                    </Col>
                                                    <Col xxl={4} md={4}>
                                                        <Label className="form-label">Site Condition{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteCondition) || ""}
                                                            onChange={e => onLocationChange(index, "siteCondition", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="Ready">Ready</option>
                                                            <option value="Not Ready">Not Ready</option>
                                                        </select>
                                                    </Col>
                                                    <Col xxl={4} md={4}>
                                                        <Label className="form-label">Inspection Type{fboState && fboState.isSiteRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canEditSite ? false : true}
                                                            value={(location.siteInspectionType) || ""}
                                                            onChange={e => onLocationChange(index, "siteInspectionType", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="Periodic">Periodic</option>
                                                            <option value="Verification">Verification</option>
                                                            <option value="Initial">Initial</option>
                                                            <option value="General">General</option>
                                                        </select>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    );
                                })}
                            </CardBody>
                        </Card>
                        }

                        {fboState && fboState.showClient &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Client Information{fboState && fboState.isClientRequired && <span className="required">*</span>}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    <Col xxl={4} md={4}>
                                        <Label className="form-label">Job Order ID{fboState && fboState.isClientRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                            value={(fboState && fboState.ineRequest.clientJobNumber) || ""}
                                            onChange={e => onIneRequestChange("clientJobNumber", e.target.value)}
                                        />
                                    </Col>
                                    <div className="clearDiv"></div>
                                    <Col xxl={4} md={4}>
                                        <Label className="form-label">Client Name{fboState && fboState.isClientRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditClient ? false : true}
                                            value={(fboState && fboState.ineRequest.clientName) || ""}
                                            onChange={e => onIneRequestChange("clientName", e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={4} md={4}>
                                        <Label className="form-label">Client Email{fboState && fboState.isClientRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className={`form-control ${clientEmailValid ? "" : "is-invalid"}`} readOnly={fboState && fboState.canEditClient ? false : true}
                                            value={(fboState && fboState.ineRequest.clientEmail) || ""}
                                            onChange={e => onIneRequestChange("clientEmail", e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={4} md={4}>
                                        <Label className="form-label">Client Contact{fboState && fboState.isClientRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditClient ? false : true}
                                            value={(fboState && fboState.ineRequest.clientContact) || ""}
                                            onChange={e => onIneRequestChange("clientContact", e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={12} md={2}>
                                        <Label className="form-label">Client Address{fboState && fboState.isClientRequired && <span className="required">*</span>}</Label>
                                        <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canEditClient ? false : true}
                                            value={(fboState && fboState.ineRequest.clientAddress) || ""}
                                            onChange={e => onIneRequestChange("clientAddress", e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        }

                        {fboState && fboState.showCertificate &&
                        <Card className="mb-0">
                            <CardHeader className="border-0 d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">Certificate/Report Information</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                <Row className="gy-2">
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Certificate/Report #{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                        <input type="text" className="form-control" readOnly={!(fboState && fboState.canEditCertificate)}
                                            value={(fboState && fboState.ineRequest.certificateNumber) || ""}
                                            onChange={e => onIneRequestChange("certificateNumber", e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Certificate/Report Issue Date{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                        <Flatpickr className="form-control"
                                            disabled={fboState && fboState.canEditCertificate ? false : true}
                                            value={(fboState && getFormattedDate(fboState.ineRequest.certificateIssueDate)) || ""}
                                            onChange={([date]) => onIneRequestChange("certificateIssueDate", date)}
                                            options={{
                                                dateFormat: "m/d/Y",
                                                maxDate: "today"
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Label className="form-label">Duration {fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                        <select className="form-select" disabled={fboState && fboState.canEditCertificate ? false : true}
                                            value={(fboState && fboState.ineRequest.certificateDuration) || ""}
                                            onChange={e => onIneRequestChange("certificateDuration", e.target.value, false)}
                                        >
                                            <option value={3}>3 months</option>
                                            <option value={6}>6 months</option>
                                            <option value={9}>9 months</option>
                                            <option value={12}>1 Year</option>
                                            <option value={-1}>Custom Date</option>
                                        </select>
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Certificate/Report Expiry Date{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                        <Flatpickr className="form-control"
                                            disabled={fboState && fboState.canEditCertificate && fboState.ineRequest.certificateDuration == -1 ? false : true}
                                            value={(fboState && getFormattedDate(fboState.ineRequest.certificateExpiryDate)) || ""}
                                            onChange={([date]) => onIneRequestChange("certificateExpiryDate", date)}
                                            options={{
                                                dateFormat: "m/d/Y"
                                            }}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Time Sheet #{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                        <input type="text" className="form-control" readOnly={!(fboState && fboState.canEditCertificate)}
                                            value={(fboState && fboState.ineRequest.timeSheetNumber) || ""}
                                            onChange={e => onIneRequestChange("timeSheetNumber", e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={12} md={12}>
                                        <Label className="form-label">Comments / Instructions</Label>
                                        <textarea maxLength={512} className="form-control" rows="5" readOnly={fboState && fboState.canEditCertificate ? false : true}
                                            value={(fboState && fboState.ineRequest.certificateComments) || ""}
                                            onChange={e => onIneRequestChange("certificateComments", e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        }

                        <div className="mb-3"></div>

                        {fboState && fboState.ineRequest.id > 0 &&
                        <TicketPhotoGrid
                            loading={loading}
                            refId={fboState.ineRequest.id}
                            refName={"INE_REQUEST"}
                            parentId={fboState.ineRequest.id}
                            parentName={"INE_REQUEST"}
                            titlePrefix={""}
                            skipAudit={fboState.skipAudit}
                            canChange={fboState.canSave}
                            onChange={onChangeDocument}
                        />
                        }

                        {fboState && fboState.ineRequest.id > 0 &&
                        <IneServiceDocumentGrid 
                            serviceId={-7}
                            refId={fboState.ineRequest.id}
                            refName={"INE_REQUEST"}
                            parentId={fboState.ineRequest.id}
                            parentName={"INE_REQUEST"}
                            isProduct={false}
                            refreshAction={refreshAction}
                            collapsed={"false"}
                            canChange={fboState.canSave}
                            onChange={onChangeDocument}

                            showContractDocument={fboState.showContractDocument}
                            canEditContractDocument={fboState.canEditContractDocument}
                            isContractDocumentRequired={fboState.isContractDocumentRequired}
                            
                            showCostEstimationDocument={fboState.showCostEstimationDocument}
                            canEditCostEstimationDocument={fboState.canEditCostEstimationDocument}
                            isCostEstimationDocumentRequired={fboState.isCostEstimationDocumentRequired}

                            showQuotationDocument={fboState.showQuotationDocument}
                            canEditQuotationDocument={fboState.canEditQuotationDocument}
                            isQuotationDocumentRequired={fboState.isQuotationDocumentRequired}

                            showPurchaseOrderDocument={fboState.showPurchaseOrderDocument}
                            canEditPurchaseOrderDocument={fboState.canEditPurchaseOrderDocument}
                            isPurchaseOrderDocumentRequired={fboState.isPurchaseOrderDocumentRequired}

                            showWorkOrderDocument={fboState.showWorkOrderDocument}
                            canEditWorkOrderDocument={fboState.canEditWorkOrderDocument}
                            isWorkOrderDocumentRequired={fboState.isWorkOrderDocumentRequired}

                            showFieldObservationDocument={fboState.showFieldObservationDocument}
                            canEditFieldObservationDocument={fboState.canEditFieldObservationDocument}
                            isFieldObservationDocumentRequired={fboState.isFieldObservationDocumentRequired}

                            showTimeTrackingDocument={fboState.showTimeTrackingDocument}
                            canEditTimeTrackingDocument={fboState.canEditTimeTrackingDocument}
                            isTimeTrackingDocumentRequired={fboState.isTimeTrackingDocumentRequired}

                            showChecklistDocument={fboState.showChecklistDocument}
                            canEditChecklistDocument={fboState.canEditChecklistDocument}
                            isChecklistDocumentRequired={fboState.isChecklistDocumentRequired}

                            showCertificateDocument={fboState.showCertificateDocument}
                            canEditCertificateDocument={fboState.canEditCertificateDocument}
                            isCertificateDocumentRequired={fboState.isCertificateDocumentRequired}
                        />
                        }

                        {fboState && fboState.ineRequest.id > 0 &&
                        <CommentGrid refId={fboState.ineRequest.id} refName="INE_REQUEST" onCommentAdd={reloadAction} />
                        }
                    </Col>

                    {fboState && fboState.ineRequest.id > 0 &&
                    <Col lg={3}>
                        <ActionList id={fboState.ineRequest.id} name={"INE_REQUEST"} refreshAction={refreshAction} />
                    </Col>
                    }
                </Row>
            </Container>

            
            
            <ConfirmModalAdvanced show={showApproveModal} onCloseClick={onCloseModalClick} onYesClick={onApproveIneRequest}>
                <div className="text-center pb-2">Are you sure you want to "Approve" the INE Ticket?</div>
                <Col xxl={12} md={12} className="pb-2">
                    <Label className="form-label">Enter Any Comments</Label>
                    <textarea maxLength={512} className="form-control" rows="5"
                        value={currentMessage || ""}
                        onChange={e => setCurrentMessage(e.target.value)}
                    />
                </Col>
            </ConfirmModalAdvanced>

            <ConfirmModalAdvanced show={showRejectModal} onCloseClick={onCloseModalClick} onYesClick={onRejectIneRequest}>
                <div className="text-center pb-2">Are you sure you want to "Reject" the INE Ticket?</div>
                <Col xxl={12} md={12} className="pb-2">
                    <Label className="form-label">Enter Any Comments</Label>
                    <textarea maxLength={512} className="form-control" rows="5"
                        value={currentMessage || ""}
                        onChange={e => setCurrentMessage(e.target.value)}
                    />
                </Col>
            </ConfirmModalAdvanced>

            <ConfirmModal message={"Are you sure you want to Assign the INE Ticket?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeTicket} />
            <ConfirmModal message={"Are you sure you want to \"Submit\" the INE Ticket?"} show={showSubmitModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Redo Cost Estimation\" the INE Ticket?"} show={showNewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={`Are you sure you want to ${getQuotationPrice() <= 10000 ? "\"Submit to Sales Action\"" : "\"Submit for Budget Approval\""} the INE Ticket?`} show={showPendingApprovalModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Sales Action\" the INE Ticket?"} show={showSalesActionModal} onCloseClick={() => setShowSalesActionModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Approval Of Contract\" the INE Ticket?"} show={showApprovalOfContractModal} onCloseClick={() => setShowApprovalOfContractModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={`${fboState && fboState.canNew ? "The ticket scope has been changed and this may affect the cost estimation. " : ""}Are you sure you want to \"${fboState && fboState.isPerformInspection ? "Area Manager Support" : "Issue Work Order Form"}\"${fboState && fboState.canNew ? " without revising the cost estimation" : " the INE Ticket"}?`} show={showIssueWorkOrderFormModal} onCloseClick={() => setShowIssueWorkOrderFormModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={`${fboState && fboState.canNew ? "The ticket scope has been changed and this may affect the cost estimation. " : ""}Are you sure you want to \"${fboState && fboState.isAwaitingSignature ? "Return to Inspector" : "Perform Inspection"}\"${fboState && fboState.canNew ? " without revising the cost estimation" : " the INE Ticket"}?`} show={showPerformInspectionModal} onCloseClick={() => setShowPerformInspectionModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Awaiting Signature\" the INE Ticket?"} show={showAwaitingSignatureModal} onCloseClick={() => setShowAwaitingSignatureModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Completed\" the INE Ticket?"} show={showCompletedModal} onCloseClick={() => setShowCompletedModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Close\" the INE Ticket?"} show={showCloseModal} onCloseClick={() => setShowCloseModal(false)} onYesClick={onSaveIneRequest} />
            <ConfirmModal message={"Are you sure you want to \"Abort\" the INE Ticket?"} show={showAbortedModal} onCloseClick={() => setShowAbortedModal(false)} onYesClick={onSaveIneRequest} />
        </div>
    );
}

export default IneRequestEditScreen;
